import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import { useFormsContext } from "../../../../context/forms/FormsContextProvider";
import FormsTable from "./FormsTable";
import Header from "./header/Header";
import AddEditForm from "../AddEditForm";

function FormsMain() {
  const { i18n } = useTranslation();
  const { state } = useLocation();
  const navigate = useNavigate();
  const isHebrew = i18n.language === "heb";
  const {
    showAddEditDialog,
    selectedForm,
    setSelectedForm,
    setShowAddEditDialog,
    copyMode,
    setCopyMode,
  } = useFormsContext();

  const handleFormOpen = useCallback((formId: string) => {
    setSelectedForm(formId);
    setShowAddEditDialog(true);
    navigate("", { replace: true });
  }, [navigate, setSelectedForm, setShowAddEditDialog]);

  useEffect(() => {
    if (state?.openFormId) {
      handleFormOpen(state.openFormId);
    }
  }, [state, handleFormOpen]);

  return (
    <>
      <div
        className={`flex-1 min-h-0 flex flex-col ${
          isHebrew ? "rounded-tl-[32px]" : "rounded-tr-[32px]"
        }`}
      >
        <Header />

        <FormsTable />
      </div>

      <AddEditForm
        open={showAddEditDialog}
        formId={selectedForm ?? undefined}
        onClose={() => {
          setSelectedForm(null);
          setShowAddEditDialog(false);
          setCopyMode(false);
        }}
        copyMode={copyMode}
      />
    </>
  );
}

export default FormsMain;
